import styled from 'styled-components';

import { breakpoint } from 'styles/mixins';

export const OpenButton = styled.span`
	cursor: pointer;
	width: 25px;
	height: 25px;
	vertical-align: middle;
	display: inline-block;

	${breakpoint.greaterThan('tablet')`
    display: none;
  `}

	.icon {
		transform: rotateY(180deg);
		display: inline-block;
	}
`;

export const Menu = styled.div`
	width: 100%;
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	direction: rtl;
	transition: all 0.4s cubic-bezier(0.19, 1, 0.22, 1);
	visibility: hidden;
	z-index: 10;

	${breakpoint.greaterThan('tablet')`
    display: none;
  `}

	.lightbox {
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.7);
		position: fixed;
		z-index: 11;
		opacity: 0;
		visibility: hidden;
		transition: ${(p) => p.theme.transition.all};
	}

	.inner {
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
		width: 100%;
		max-width: 280px;
		background-color: #fff;
		visibility: hidden;
		transform: translateX(-110%);
		padding: 60px 20px 20px;
		z-index: 12;
		transition: 0.6s cubic-bezier(0.19, 1, 0.22, 1);
		box-shadow: 0 4px 30px rgba(8, 29, 41, 0.3);
		border-radius: 0 15px 15px 0;
	}

	&.show {
		visibility: visible;

		.lightbox {
			opacity: 1;
			visibility: visible;
		}

		.inner {
			transform: translateX(0);
			visibility: visible;
		}
	}
`;

export const Nav = styled.nav`
	a {
		display: block;
	}

	.link {
		padding-top: 10px;
		padding-bottom: 10px;
		margin-bottom: 10px;
		color: ${(p) => p.theme.color.black};
		margin-left: 15px;

		&:hover {
			color: ${(p) => p.theme.color.primary};
		}

		${breakpoint.greaterThan('tablet')`
		  padding-top: 8px;
      padding-bottom: 0;
      margin-bottom: 0;
    `}
	}
`;

export const NavHolder = styled.div`
	display: none;

	${breakpoint.greaterThan('tablet')`
    display: block;
  `}

	a {
		display: inline-block;
		float: right;
	}
`;

export const Close = styled.button`
	cursor: pointer;
	width: 60px;
	height: 60px;
	position: absolute;
	left: 0;
	top: 0;
	border: 0;
	background: none;

	.icon {
		font-size: 14px;
	}
`;
